import { createContext, useContext } from 'react';

export type AppAuthContextValue = {
  isAuthChecked: boolean;
};

export const AppAuthContext = createContext<AppAuthContextValue>({
  isAuthChecked: false,
});

export const useAppAuth = (): AppAuthContextValue => useContext(AppAuthContext);
